"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    XXS: '4px',
    XS: '8px',
    SM: '12px',
    MD: '16px',
    LG: '20px',
    XL: '24px',
    XXL: '32px',
    XXXL: '64px',
};
